<script lang="ts" setup>
import { ChecklistCriteria, CriteriaInstance } from "types/Checklist";
import { useChecklistControllerStore } from "~/composables/useChecklistControllerStore";

const { criteriaInstance } = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  checklistCriteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
});
const documentId = inject("documentId") as any;

const { setCurrentChecklistCriteriaInstance } =
  useChecklistControllerStore(documentId);

const navigateBack = () => {
  setCurrentChecklistCriteriaInstance(undefined);
};
</script>

<template>
  <div class="flex flex-col min-h-0">
    <!-- <div class="flex flex-row">
      <BaseTextButton @click="navigateBack" class="flex flex-row items-center">
        <icon
          name="ion:arrow-back-outline"
          class="mr-1"
        />
        <span>back</span>
      </BaseTextButton>
    </div> -->
    <DocumentPanelChecklistStep
      :checklist-criteria="checklistCriteria"
      :criteria-instance="criteriaInstance"
      class="pt-2"
    />
  </div>
</template>

<style scoped></style>
